// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('agencyManagement', ['$http', 'obexConstant', 'authService',
    function($http, obexConstant, authService) {
      let showAll = false;
      return {
        setShowAll(showAllAgencies) {
          showAll = showAllAgencies;
        },
        getShowAll() {
          return showAll;
        },
        addOrganization(organization) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const postData = {
              Id: organization.Id,
              Name: organization.Name,
              AddressLine1: organization.AddressLine1,
              AddressLine2: organization.AddressLine2,
              City: organization.City,
              PostalCode: organization.PostalCode,
              Country: organization.Country,
              StateProv: organization.StateProv,
              IsTravelAgency: organization.IsTravelAgency,
              TravelAgencyId: organization.TravelAgencyId,
              HasConcur: organization.HasConcur,
              Domains: organization.Domains,
              AcceptEmails: organization.AcceptEmails,
              WebSite: organization.WebSite,
              LogoImageLink: organization.LogoImageLink,
            };
            return $http.post(obexConstant.urlOrganization, postData, {
              headers: authHeader,
            });
          });
        },
        getOrganizations() {
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(obexConstant.urlOrganization, {
              headers: authHeader,
            });
          });
        },
        getOrganizationById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getClients() {
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(obexConstant.urlClients, {
              headers: authHeader,
            });
          });
        },
        getAgencies(includeAllAgencies = false) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = includeAllAgencies === true ? obexConstant.urlAgencies+'/'+includeAllAgencies : obexConstant.urlAgencies;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        updateOrganization(id, organization) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            const putData = {
              Id: organization.Id,
              Name: organization.Name,
              AddressLine1: organization.AddressLine1,
              AddressLine2: organization.AddressLine2,
              City: organization.City,
              PostalCode: organization.PostalCode,
              Country: organization.Country,
              StateProv: organization.StateProv,
              IsTravelAgency: organization.IsTravelAgency,
			        Inactive: organization.Inactive,
              TravelAgencyId: organization.TravelAgencyId,
              HasConcur: organization.HasConcur,
              Domains: organization.Domains,
              AcceptEmails: organization.AcceptEmails,
              WebSite: organization.WebSite,
              LogoImageLink: organization.LogoImageLink,
              DefaultPhone: organization.DefaultPhone,
            };
            if(organization.DefaultAfterHoursPhone !== null){
              putData["DefaultAfterHoursPhone"] = organization.DefaultAfterHoursPhone;
            }
            if(organization.DefaultInternationalPhone !== null){
              putData["DefaultInternationalPhone"] = organization.DefaultInternationalPhone;	
            }
            if(organization.DefaultEmail !== null){
              putData["DefaultEmail"] = organization.DefaultEmail;
            }
            if (organization.DefaultStartRegularHours !== null) {
              putData["DefaultStartRegularHours"] = organization.DefaultStartRegularHours;
            }
            if (organization.DefaultEndRegularHours !== null) {
              putData["DefaultEndRegularHours"] = organization.DefaultEndRegularHours;
            }
            if (organization.DefaultWindowsTimeZone !== null) {
              putData["DefaultWindowsTimeZoneId"] = organization.DefaultWindowsTimeZone.Id;
            }
            if (organization.DefaultServiceStartDay !== null) {
              putData["DefaultServiceStartDay"] = organization.DefaultServiceStartDay;
            }
            if (organization.DefaultServiceEndDay !== null) {
              putData["DefaultServiceEndDay"] = organization.DefaultServiceEndDay;
            }
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },
        deleteOrganization(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },
        getCountries() {
          return $http.get('/js/content/countryData.json');
        },
        getStates() {
          return $http.get('/js/content/stateData.json');
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/agencyManagement.service.js